var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconStarWithValue"},[_c('starIcon',{staticClass:"iconStarWithValue__icon"}),_c('span',{staticClass:"iconStarWithValue__value"},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }